<app-modern-template-home-page *ngIf="homePage == 'modern_home_page'">
</app-modern-template-home-page>

<app-modern-template-default-home-page *ngIf="homePage == 'default_home_page'">
</app-modern-template-default-home-page>   
